















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { signOut} from '@/utils/login';
import { User } from '@/models/user';

@Component
export default class NavMenu extends Vue {
    logout() {
        signOut();
    }

    @Prop()
    private user!: User;
}
